//预加载图片资源
export default [
	require('@/assets/img/theme/new-year-2020/style1.png'),
	require('@/assets/img/theme/new-year-2020/style2.png'),
	require('@/assets/img/theme/new-year-2020/style3.png'),
	require('@/assets/img/theme/new-year-2020/style4.png')
];
